import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "./pages/LandingPage";
import BlogsPage from "./pages/BlogsPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import DemoDialog from "./components/landing/DemoDialog";

function App() {
  const [demoOpen, setDemoOpen] = useState(false);
  const openDemo = () => setDemoOpen(true);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage onDemoClick={openDemo} />} />
          <Route path="/blogs" element={<BlogsPage onDemoClick={openDemo} />} />
          <Route
            path="/blogs/:slug"
            element={<BlogDetailPage onDemoClick={openDemo} />}
          />
        </Routes>
        <DemoDialog open={demoOpen} onClose={() => setDemoOpen(false)} />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#12121A",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#fff",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
